import React from 'react';
import { CTAButton } from '../components/CTAButton';
import { SectionReveal } from '../components/SectionReveal';
import { ZapIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-brand-darker" data-id="element-88">
      {/* Background effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-darker via-brand-dark to-brand-darker" data-id="element-89" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-gold/5 rounded-full blur-3xl" data-id="element-90" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-brand-red/5 rounded-full blur-3xl" data-id="element-91" />

      {/* Subtle grid pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: 'linear-gradient(rgba(255,215,0,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255,215,0,0.3) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-92" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 py-20 text-center" data-id="element-93">
        <SectionReveal data-id="element-94">
          <div className="inline-flex items-center gap-2 bg-brand-gold/10 border border-brand-gold/20 rounded-full px-5 py-2 mb-8" data-id="element-95">
            <ZapIcon className="w-5 h-5 text-brand-gold" aria-hidden="true" data-id="element-96" />
            <span className="text-brand-gold font-body text-sm font-semibold uppercase tracking-wider" data-id="element-97">
              bAJÁ Tu Factura UN 60%
            </span>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.1} data-id="element-98">
          <h1 className="font-heading font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.1] mb-6 text-shimmer" data-id="element-99">
            ESTÁS PAGANDO DE MÁS EN LA LUZ (Y NO LO SABÉS)
          </h1>
        </SectionReveal>

        <SectionReveal delay={0.2} data-id="element-100">
          <p className="text-lg sm:text-xl md:text-2xl text-gray-200 font-body leading-relaxed max-w-3xl mx-auto mb-6" data-id="element-101">
            Descubrí cómo bajar tu factura hasta un 60% este mes, sin
            conocimientos técnicos y sin hacer nada ilegal.
          </p>
        </SectionReveal>

        <SectionReveal delay={0.3} data-id="element-102">
          <p className="text-base sm:text-lg text-brand-gold/80 font-body font-semibold mb-10" data-id="element-103">
            👉 Miles de personas ya están pagando menos
          </p>
        </SectionReveal>

        <SectionReveal delay={0.4} data-id="element-104">
          <CTAButton text="DESCARGAR GUÍA AHORA" size="xl" data-id="element-105" />
        </SectionReveal>

        {/* Decorative bottom fade */}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-brand-dark to-transparent" data-id="element-106" />
      </div>
    </section>;
}